/* product-info-modal.js */
(function () {
    if (window.ProductInfoModalInitialized) return;
    window.ProductInfoModalInitialized = true;

    const closeModal = (modal) => {
        if (!modal) return;
        modal.classList.remove('active');
        modal.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('overflow-hidden');
    };

    const openTab = (modal, idx) => {
        const tabBtns = modal.querySelectorAll('.product-info-modal__tab-btn');
        const tabContents = modal.querySelectorAll('.product-info-modal__tab-content');
        tabBtns.forEach((btn, i) => btn.classList.toggle('active', i === idx));
        tabContents.forEach((content, i) => content.classList.toggle('active', i === idx));
    };

    // Use mousedown for background clicks to bypass stopPropagation on click
    document.addEventListener('mousedown', (e) => {
        // Handle Overlay Click
        if (e.target.classList.contains('product-info-modal__overlay')) {
            const modal = e.target.closest('.product-info-modal');
            closeModal(modal);
        }
    });

    document.addEventListener('click', (e) => {
        // 1. Handle Trigger (Open)
        const trigger = e.target.closest('[data-product-info-modal-trigger]');
        if (trigger) {
            e.preventDefault();
            const modalId = trigger.getAttribute('data-product-info-modal-trigger');
            const tabIndex = parseInt(trigger.getAttribute('data-tab-index') || 0);
            const modal = document.getElementById(modalId);
            if (modal) {
                openTab(modal, tabIndex);
                modal.classList.add('active');
                modal.setAttribute('aria-hidden', 'false');
                document.body.classList.add('overflow-hidden');
            }
            return;
        }

        // 2. Handle Close Button
        const isCloseBtn = e.target.closest('.product-info-modal__close');
        if (isCloseBtn) {
            const modal = e.target.closest('.product-info-modal');
            closeModal(modal);
            return;
        }

        // 3. Handle Tab Switch
        const tabBtn = e.target.closest('.product-info-modal__tab-btn');
        if (tabBtn) {
            const modal = tabBtn.closest('.product-info-modal');
            const idx = Array.from(modal.querySelectorAll('.product-info-modal__tab-btn')).indexOf(tabBtn);
            openTab(modal, idx);
            return;
        }
    });

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
            closeModal(document.querySelector('.product-info-modal.active'));
        }
    });

    // Login/Register/Recover Toggle Logic
    document.addEventListener('click', (e) => {
        const toRegister = e.target.closest('#ToggleToRegister');
        const toLogin = e.target.closest('#ToggleToLogin, #RecoverToLogin');
        const toRecover = e.target.closest('#ToggleToRecover');
        const modal = document.getElementById('LoginDrawer');
        if (!modal) return;

        const title = modal.querySelector('.login-popup__title');
        const loginForm = modal.querySelector('.login-popup__form-login');
        const registerForm = modal.querySelector('.login-popup__form-register');
        const recoverForm = modal.querySelector('.login-popup__form-recover');

        if (toRegister) {
            e.preventDefault();
            [loginForm, recoverForm].forEach(f => f?.classList.remove('active'));
            registerForm?.classList.add('active');
            if (title) title.textContent = 'Create Account';
        } else if (toLogin) {
            e.preventDefault();
            [registerForm, recoverForm].forEach(f => f?.classList.remove('active'));
            loginForm?.classList.add('active');
            if (title) title.textContent = 'Sign In';
        } else if (toRecover) {
            e.preventDefault();
            [loginForm, registerForm].forEach(f => f?.classList.remove('active'));
            recoverForm?.classList.add('active');
            if (title) title.textContent = 'Reset Password';
        }
    });

    const isValidEmail = (email) => String(email).toLowerCase().endsWith('@gmail.com');

    const updateStatus = (id, text, display = 'block') => {
        const el = document.getElementById(id);
        if (el) {
            el.style.display = display;
            if (text) el.textContent = text;
        }
    };

    const toggleButton = (btn, text, disabled) => {
        if (!btn) return;
        btn.disabled = disabled;
        btn.textContent = text;
    };

    // Password Visibility Toggle
    document.addEventListener('click', (e) => {
        const toggle = e.target.closest('.login-popup__password-toggle');
        if (!toggle) return;

        const input = toggle.parentElement.querySelector('input');
        const eyeOpen = toggle.querySelector('.login-popup__icon-eye-open');
        const eyeClosed = toggle.querySelector('.login-popup__icon-eye-closed');
        const isPass = input.type === 'password';

        input.type = isPass ? 'text' : 'password';
        if (eyeOpen) eyeOpen.style.display = isPass ? 'none' : 'block';
        if (eyeClosed) eyeClosed.style.display = isPass ? 'block' : 'none';
    });

    // Modal Reset on Open/Close
    const resetModalForms = (modal) => {
        if (!modal) return;
        modal.querySelectorAll('form').forEach(f => f.reset());
        modal.querySelectorAll('.login-popup__error-text').forEach(el => el.textContent = '');

        ['LoginPopup-Success', 'LoginPopup-GeneralError', 'RegisterPopup-Success', 'RegisterPopup-GeneralError']
            .forEach(id => updateStatus(id, '', 'none'));

        const loginForm = modal.querySelector('.login-popup__form-login');
        const regForm = modal.querySelector('.login-popup__form-register');
        const recoverForm = modal.querySelector('.login-popup__form-recover');
        const title = modal.querySelector('.login-popup__title');

        if (loginForm) {
            loginForm.classList.add('active');
            toggleButton(loginForm.querySelector('.login-popup__submit-button'), 'Sign in', false);
        }
        if (regForm) {
            regForm.classList.remove('active');
            toggleButton(regForm.querySelector('.login-popup__submit-button'), 'Create Account', false);
        }
        if (recoverForm) {
            recoverForm.classList.remove('active');
            toggleButton(recoverForm.querySelector('.login-popup__submit-button'), 'Reset Password', false);
        }
        if (title) title.textContent = 'Sign In';

        modal.querySelectorAll('input[type="text"]').forEach(input => {
            if (input.id.includes('Password')) {
                input.type = 'password';
                const toggle = input.parentElement.querySelector('.login-popup__password-toggle');
                if (toggle) {
                    const eyeOpen = toggle.querySelector('.login-popup__icon-eye-open');
                    const eyeClosed = toggle.querySelector('.login-popup__icon-eye-closed');
                    if (eyeOpen) eyeOpen.style.display = 'block';
                    if (eyeClosed) eyeClosed.style.display = 'none';
                }
            }
        });
    };

    document.addEventListener('click', (e) => {
        const trigger = e.target.closest('[data-product-info-modal-trigger="LoginDrawer"]');
        if (trigger) resetModalForms(document.getElementById('LoginDrawer'));

        const closeBtn = e.target.closest('.product-info-modal__close');
        if (closeBtn) resetModalForms(e.target.closest('.product-info-modal'));
    });

    document.addEventListener('mousedown', (e) => {
        if (e.target.classList.contains('product-info-modal__overlay')) {
            resetModalForms(e.target.closest('.product-info-modal'));
        }
    });
})();
